export function parseDate(utcDate: string): Date {
	return new Date(Date.parse(utcDate));
}
